export { default } from "./hasUserAgentRole";
